import { Controller } from "stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ["element"]

  connect() {
      console.log("submit form loaded")
  }

  submitForm(){
    var form_id = this.elementTarget.getAttribute('data-form-id')
    var form = document.getElementById(form_id);
    console.log('[submit-form] Submitting form:', form_id)
    console.log('[submit-form] Preset field value:', document.getElementById('presetField')?.value)
    console.log('[submit-form] Prompt field value:', document.getElementById('promptField')?.value?.substring(0, 50))
    setTimeout(() => {Rails.fire(form, "submit")}, 200);
  }

};